import { useCallback } from 'react';

type FileContents = {
  content: string;
  filename: string;
};

type LoadFileFunction = () => Promise<{
  file: FileContents | null;
}>;

/**
 * Hook to select a markdown file and return the contents.
 * @returns A function to select a markdown file and return the contents.
 */
const useSelectMdFile = (): LoadFileFunction => {
  const handleFileSelection: LoadFileFunction = useCallback(async () => {
    return new Promise((resolve) => {
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = '.md';

      input.onchange = async (e) => {
        const file = (e.target as HTMLInputElement).files?.[0];
        if (file && file.name.endsWith('.md')) {
          const text = await file.text();
          resolve({
            file: {
              content: text,
              filename: file.name,
            }
          });
        } else {
          resolve({
            file: null,
          });
        }
      };

      input.onerror = (e) => {
        console.error('Error selecting file:', e);
        resolve({
          file: null,
        });
      };

      input.click();
    });
  }, []);

  return handleFileSelection;

};

export default useSelectMdFile;
